export default __webpack_public_path__ + "static/media/search.3cd4e20e.svg";